import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import './folding-content.min.js';



$(function () {
    if ($('.folding-menu').length) {
      $('.folding-menu').foldingContent({
        menuSelector: '.folding-menu',
        menuItemSelector: '.menu-item',
        contentSelector: '.folding-content',
        unfoldBeforeMarkup: '<li>',
        unfoldAfterMarkup: '</li>',
        closeMarkup: '<span class="your-icon-class">X</span>'
      });
    }
  });